/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Loadable } from "components/Loadable";
import { MainLayout } from "layout/MainLayout";
import { lazy } from "react";
import { NavigationContextWrapper } from "sections/navigation-context-wrapper";
import { AuthGuard } from "utils/route-guard/AuthGuard";
import { PermissionContextWrapper } from "./permission-context-wrapper";
// Routes
import { applicationRoutes } from "sections/applications/application-route";
import { componentRoutes } from "sections/components/components-route";
import { composerRoutes } from "sections/composer/composer-route";
import { dashboardRoutes } from "sections/dashboard/dashboard-routes";
import { dataRoutes } from "sections/data/data-route";
import { digitalAssetsRoutes } from "sections/digital_assets/digital-assets-routes";
import { formsRoutes } from "sections/forms/forms-route";
import { modelRoutes } from "sections/models/models-route";
import { organizationRoutes } from "sections/organization/organization-route";
import { settingsRoutes } from "sections/settings/settings-route";
import { profileRoutes } from "sections/profile/profile-route";
import { styleGuideRoutes } from "sections/style-guide/style-guide-routes";
import { taskRoutes } from "sections/tasks/tasks-route";
import { testingRoutes } from "sections/testing/testing-route";
import { websiteRoutes } from "sections/website/website-route";


// -------------------------------------------------------
//    Menu Options are found in Menu-Config
//    sections/menu-config
// -------------------------------------------------------

const Dashboard = Loadable(lazy(() => import("sections/dashboard/index")));

const root = [
    {
        path: "/",
        element: <Dashboard />,
    },
];

const MainRoutes = {
    path: "/",
    element: (
        <AuthGuard>
            <NavigationContextWrapper>
                <PermissionContextWrapper>
                    <MainLayout />
                </PermissionContextWrapper>
            </NavigationContextWrapper>
        </AuthGuard>
    ),
    children: [
        ...root,
        ...dashboardRoutes,
        ...taskRoutes,
        ...composerRoutes,
        ...websiteRoutes,
        ...applicationRoutes,
        ...modelRoutes,
        ...componentRoutes,
        ...dataRoutes,
        ...formsRoutes,
        ...digitalAssetsRoutes,
        ...organizationRoutes,
        ...styleGuideRoutes,
        ...settingsRoutes,
        ...profileRoutes,
        ...testingRoutes,
    ],
};

export { MainRoutes };
